import { Navigate } from "src/router";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { lazyNamed } from "src/utils/lazy-named";

const ExperimentSchedule = lazyNamed(
  () => import("./experiment-schedule"),
  "ExperimentSchedule",
);

const experimentsImport = () => import("src/pages/experiments");
const Experiments = lazyNamed(experimentsImport, "Experiments");

export const preloads: RoutePreload[] = [["/experiments", experimentsImport]];
const ExperimentPage = lazyNamed(
  () => import("src/pages/experiments/experiment"),
  "ExperimentPage",
);
const ExperimentConfiguration = lazyNamed(
  () => import("src/pages/experiments/experiment-configuration"),
  "ExperimentConfiguration",
);
const ExperimentOverview = lazyNamed(
  () => import("src/pages/experiments/experiment-overview"),
  "ExperimentOverview",
);

export const routes: RouteObject[] = [
  {
    path: "experiments",
    spacesAccess: "hidden-from-limited-view",
    children: [
      {
        index: true,
        spacesAccess: "hidden-from-limited-view",
        element: <Experiments />,
      },
      {
        path: ":experimentId",
        spacesAccess: "hidden-from-limited-view",
        element: <ExperimentPage />,
        children: [
          {
            index: true,
            spacesAccess: "hidden-from-limited-view",
            element: <Navigate to="overview" />,
          },
          {
            path: "overview",
            spacesAccess: "hidden-from-limited-view",
            element: <ExperimentOverview />,
          },
          {
            path: "configuration",
            spacesAccess: "hidden-from-limited-view",
            element: <ExperimentConfiguration />,
          },
          {
            path: "schedule",
            spacesAccess: "hidden-from-limited-view",
            element: <ExperimentSchedule />,
          },
        ],
      },
    ],
  },
];
